import { configureStore, combineReducers } from "@reduxjs/toolkit";
import userReducer from "../store/slices/usersSlice";
import authReducer from "../store/slices/authSlice";
import boxReducer from "../store/slices/box";
import orderReducer from "../store/slices/order";
import { userApi } from "./api/userAPI";
import { orderApi } from "./api/orderAPI";
import { categoryApi } from "./api/directory/categoryApi";
import { currencyApi } from "./api/directory/currencyApi";
import { recieverApi } from "./api/directory/recieverApi";
import { regionApi } from "./api/directory/regionApi";
import { countryApi } from "./api/directory/countryApi";
import { customerApi } from "./api/customerApi";
import { tarifApi } from "./api/tarifApi";
import { employeeApi } from "./api/employeeApi";
import { storeApi } from "./api/directory/storeApi";
import { balanceApi } from "./api/balanceAPI";
import { boxApi } from "./api/boxApi";
import { warehouseApi } from "./api/directory/warehouse";
import { partialApi } from "./api/partialApi";
import { actionsApi } from "./api/actions";
import { typesApi } from "./api/directory/typeApi";
import { rolesApi } from "./api/directory/roleApi";
import { buyForMeAPI } from "./api/buyForMeAPI";
import { orderSortApi } from "./api/orderSortApi";
import { statusApi } from "./api/directory/statusApi";
import { pickupApi } from "./api/directory/pickupApi";

// 1. Собираем все редьюсеры в один appReducer
const appReducer = combineReducers({
  user: userReducer,
  auth: authReducer,
  box: boxReducer,
  order: orderReducer,
  [userApi.reducerPath]: userApi.reducer,
  [orderApi.reducerPath]: orderApi.reducer,
  [orderSortApi.reducerPath]: orderSortApi.reducer,
  [buyForMeAPI.reducerPath]: buyForMeAPI.reducer,
  [categoryApi.reducerPath]: categoryApi.reducer,
  [currencyApi.reducerPath]: currencyApi.reducer,
  [recieverApi.reducerPath]: recieverApi.reducer,
  [countryApi.reducerPath]: countryApi.reducer,
  [customerApi.reducerPath]: customerApi.reducer,
  [regionApi.reducerPath]: regionApi.reducer,
  [tarifApi.reducerPath]: tarifApi.reducer,
  [storeApi.reducerPath]: storeApi.reducer,
  [balanceApi.reducerPath]: balanceApi.reducer,
  [warehouseApi.reducerPath]: warehouseApi.reducer,
  [typesApi.reducerPath]: typesApi.reducer,
  [statusApi.reducerPath]: statusApi.reducer,
  [actionsApi.reducerPath]: actionsApi.reducer,
  [pickupApi.reducerPath]: pickupApi.reducer,
  [partialApi.reducerPath]: partialApi.reducer,
  [rolesApi.reducerPath]: rolesApi.reducer,
  [boxApi.reducerPath]: boxApi.reducer,
  [employeeApi.reducerPath]: employeeApi.reducer,
});

// 2. Добавляем rootReducer с очисткой store при logout
const rootReducer = (state, action) => {
  if (action.type === "auth/deleteAuth") {
    state = undefined; // очистка всего redux store
  }
  return appReducer(state, action);
};

// 3. Создаём store на основе rootReducer
export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .concat(userApi.middleware)
      .concat(orderApi.middleware)
      .concat(currencyApi.middleware)
      .concat(statusApi.middleware)
      .concat(buyForMeAPI.middleware)
      .concat(partialApi.middleware)
      .concat(recieverApi.middleware)
      .concat(regionApi.middleware)
      .concat(boxApi.middleware)
      .concat(orderSortApi.middleware)
      .concat(rolesApi.middleware)
      .concat(countryApi.middleware)
      .concat(pickupApi.middleware)
      .concat(tarifApi.middleware)
      .concat(customerApi.middleware)
      .concat(actionsApi.middleware)
      .concat(storeApi.middleware)
      .concat(employeeApi.middleware)
      .concat(balanceApi.middleware)
      .concat(warehouseApi.middleware)
      .concat(typesApi.middleware)
      .concat(categoryApi.middleware),
});
